import { getJson, postJson, patchJson, postFile, del, putJson } from './fetch';
import localForage from 'localforage';
// import './api-mock';

const apiBase = '/v1';

export const getTestMessage = () =>
  getJson({
    path: `${apiBase}/example`
  });

export const getRestaurants = payload =>
  getJson({
    path: `${apiBase}/examples/restaurants`,
    payload
  });

export const getRestaurant = ({ _id }) =>
  getJson({
    path: `${apiBase}/examples/restaurants/${_id}`
  });

export const patchRestaurant = ({ _id, values }) =>
  patchJson({
    path: `${apiBase}/examples/restaurants/${_id}`,
    payload: values
  });

export const getCuisines = payload =>
  getJson({
    path: `${apiBase}/examples/restaurants/lookups/cuisines`
  });

export const getMusic = payload =>
  getJson({
    path: `${apiBase}/examples/music`,
    payload
  });

export const getAlbum = payload =>
  getJson({
    path: `${apiBase}/examples/music/albums/${payload.id}`
  });

export const patchAlbum = ({ id, values }) =>
  patchJson({
    path: `${apiBase}/examples/music/albums/${id}`,
    payload: values
  });

export const getArtists = payload =>
  getJson({
    path: `${apiBase}/examples/music/artists`,
    payload
  });

export const getAuditLog = () =>
  getJson({
    path: `${apiBase}/audit-log`
  });

export const getType = (type) =>
  getJson({
    path: `${apiBase}/types/${type}`
  });
  
export const postAsset = ({ type, payload }) =>
  postJson({
    path: `${apiBase}/assets/${type}`,
    payload
  });
  
export const putAsset = ({ type, id, payload }) =>
  putJson({
    path: `${apiBase}/assets/${type}/${id}`,
    payload
  });
  
export const getAsset = ({ type, id }) =>
  getJson({
    path: `${apiBase}/assets/${type}/${id}`
  });
  
export const getAssetsByType = ({ type }) =>
  getJson({
    path: `${apiBase}/assets/${type}`
  });

  
export const getAssetSiblings = ({ type, id }) =>
  getJson({
    path: `${apiBase}/assets/${type}/${id}/siblings`,
  });
  
export const getAssetSiblingsByParent = ({ type, id }) =>
  getJson({
    path: `${apiBase}/assets/${type}/${id}/children`,
  });
  
export const publishAsset = ({ type, id, payload }) =>
  postJson({
    path: `${apiBase}/assets/${type}/${id}/publish`,
    payload
  });
  
export const restoreAsset = ({ type, id }) =>
  postJson({
    path: `${apiBase}/assets/${type}/${id}/restore`,
    payload: {}
  });

export const getAllTypes = () =>
  getJson({
    path: `${apiBase}/types`
  });

export const uploadFile = ({ files, folder, filenames }) => {
  const payload = new FormData();
  files.map((file, idx) => {
    payload.append(`file[${idx}]`, file);
    payload.append(`filenames[${idx}]`, filenames[idx]);
    
  })
  payload.append('folder', folder);
  return postFile({
    path: `${apiBase}/files`,
    payload
  });
}

export const getAllFiles = () =>
  getJson({
    path: `${apiBase}/files`,
  });

export const getFileDetail = (_id) =>
  getJson({
    path: `${apiBase}/files/detail/${_id}`,
  });

export const postFolder = payload =>
  postJson({
    path: `${apiBase}/folders`,
    payload
  });

export const deleteFile = id =>
  del({
    path: `${apiBase}/files/${id}`
  });

export const getTags = value =>
  getJson({
    path: `${apiBase}/tags/search/${value}`
  });

export const getAllTags = () =>
  getJson({
    path: `${apiBase}/tags`
  });

export const getTagById = id =>
  getJson({
    path: `${apiBase}/tags/${id}`
  });

export const deleteTagById = id =>
  del({
    path: `${apiBase}/tags/${id}`
  });

export const postTag = ({ value, color }) =>
  postJson({
    path: `${apiBase}/tags`,
    payload: { value, color }
  });

export const putTag = ({ payload, id }) =>
  putJson({
    path: `${apiBase}/tags/${id}`,
    payload
  });

export const deleteAsset = ({ id }) =>
  del({
    path: `${apiBase}/assets/asset-parent/${id}`,
  });

export const deleteVersion = ({ id }) =>
  del({
    path: `${apiBase}/assets/${id}`,
  });

export const getAssetByParentId = ({ id, type }) =>
  getJson({
    path: `${apiBase}/assets/${type}/asset-parent/${id}`,
  });

export const patchVersionName = ({ id, type, payload }) =>
  patchJson({
    path: `${apiBase}/assets/${type}/version-name/${id}`,
    payload
  });

export const updateDisplayOrder = ({ type, payload }) =>
  postJson({
    path: `${apiBase}/assets/${type}/display-order`,
    payload
  });

export const postLogin = payload =>
  postJson({
    path: `${apiBase}/identity/login`,
    payload
  }).then(result => {
    localForage.setItem('identity', result);
    return result;
  });



// WEBPACK FOOTER //
// ./src/api/api.js